import { CbhIcon, Text } from "@clipboard-health/ui-components";
import { isDefined } from "@clipboard-health/util-ts";
import { Box, ButtonBase, Stack } from "@mui/material";

import { formatDistance } from "../../../Workplace/useDistanceToWorkplace";
import { type FacilityWithDistance } from "../../data/schemas";

interface EarlyAccessFacilityListItemProps {
  facility: FacilityWithDistance;
  onClick: () => void;
  showDividerAfter?: boolean;
}

export function EarlyAccessFacilityListItem(props: EarlyAccessFacilityListItemProps) {
  const { facility, onClick, showDividerAfter = false } = props;
  const { name, address, city, state, zipCode, distance } = facility;
  const fullAddress = `${address}, ${city}, ${state} ${zipCode}`;

  return (
    <Box
      sx={(theme) => ({
        pb: showDividerAfter ? 5 : 0,
        borderBottom: showDividerAfter ? `1px solid ${theme.palette.divider}` : "none",
      })}
    >
      <ButtonBase
        sx={{
          width: "100%",
          textAlign: "left",
          px: 5,
          py: 3,
        }}
        onClick={onClick}
      >
        <Stack direction="row" spacing={2} width="100%">
          <CbhIcon type="map-pin" size="medium" />
          <Stack alignItems="flex-start" width="100%" gap={1}>
            <Text variant="body1" sx={{ fontWeight: "medium" }}>
              {name}
            </Text>
            <Stack spacing={0.5}>
              <Text variant="body2" color={(theme) => theme.palette.text.secondary}>
                {fullAddress}
              </Text>
              {isDefined(distance) && (
                <Text semibold variant="caption" color={(theme) => theme.palette.text.secondary}>
                  {formatDistance(distance)} away
                </Text>
              )}
            </Stack>
          </Stack>
        </Stack>
      </ButtonBase>
    </Box>
  );
}
